import {SponsoredAdverts as ISponsoredAdverts} from "@proto/chatbot/v1alpha/chatbot"
import BotMessage from "./BotMessage"
import ProductsMessage from "./ProductsMessage"

interface IProps {
    message: string
}

const parse = (msg: string): ISponsoredAdverts | false => {
    try {
        return JSON.parse(msg)
    } catch (e) {
        console.error(e)
        return false
    }
}

const SponsoredAdvertsMessage = ({message}: IProps) => {
    try {
        const content = parse(message)
        if (!content) {
            return
        }

        return (
            <div className="relative">
                <BotMessage message={content.text} />
                <ProductsMessage products={content.products} />
            </div>
        )
    } catch (e) {
        return
    }
}

export default SponsoredAdvertsMessage
